import clsx from 'clsx';

interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const sizes = { sm: 'w-4 h-4 border-2', md: 'w-7 h-7 border-2', lg: 'w-10 h-10 border-2' };

export function Spinner({ size = 'md', className }: SpinnerProps) {
  return (
    <span className={clsx(
      'inline-block rounded-full border-primary border-t-transparent spinner',
      sizes[size],
      className,
    )} />
  );
}

export function FullPageSpinner() {
  return (
    <div className="flex items-center justify-center min-h-screen bg-surface0">
      <Spinner size="lg" />
    </div>
  );
}
